/* Postgres speaks snake_case; the ported screens speak camelCase.
   Translating in one place keeps every screen component unchanged from the
   prototype and keeps column names out of the UI. */

export function itemFromRow(row, historyRows = []) {
  return {
    id: row.id,
    category: row.category,
    brand: row.brand,
    model: row.model,
    colorway: row.colorway || "",
    sku: row.sku || "",
    size: row.size,
    releaseDate: row.release_date,
    dateAdded: row.date_added,
    // When the row was created, as distinct from date_added — which is the
    // purchase date the collector typed in and can be years earlier. The
    // Passport list offers both as separate sorts.
    createdAt: row.created_at,
    retail: Number(row.retail) || 0,
    value: Number(row.value) || 0,
    purchasedFrom: row.purchased_from || "",
    authentication: row.authentication || "",
    authDate: row.auth_date,
    materials: row.materials || {},
    status: row.status,
    wears: row.wears ?? 0,
    lastWorn: row.last_worn,
    lastCleaned: row.last_cleaned,
    lastRotated: row.last_rotated,
    condition: row.condition ?? 100,
    photos: Array.isArray(row.photos) ? row.photos : [],
    history: historyRows.map(historyFromRow),
  };
}

export function historyFromRow(row) {
  return { id: row.id, action: row.action, date: row.date };
}

/** Shapes wizard output into an insertable row. `userId` is set explicitly
 *  because the RLS insert policy checks it against auth.uid(). */
export function itemToInsert(data, userId) {
  return {
    user_id: userId,
    category: data.category,
    brand: data.brand,
    model: data.model,
    colorway: data.colorway || null,
    sku: data.sku || null,
    size: data.size || null,
    release_date: data.releaseDate || null,
    date_added: data.dateAdded,
    retail: data.retail ?? 0,
    value: data.value ?? 0,
    purchased_from: data.purchasedFrom || null,
    authentication: data.authentication || null,
    auth_date: data.authDate || null,
    materials: data.materials || {},
    status: data.status,
    photos: data.photos || [],
    wears: 0,
    condition: 100,
  };
}

/** Every field the Edit screen can change, as columns. Deliberately excludes
 *  wears, condition, last_* and history — those are earned by logging actions,
 *  not typed into a form, and editing details shouldn't disturb them. */
export function itemToUpdate(data) {
  return {
    category: data.category,
    brand: data.brand,
    model: data.model,
    colorway: data.colorway || null,
    sku: data.sku || null,
    size: data.size || null,
    release_date: data.releaseDate || null,
    date_added: data.dateAdded,
    retail: data.retail ?? 0,
    value: data.value ?? 0,
    purchased_from: data.purchasedFrom || null,
    authentication: data.authentication || null,
    auth_date: data.authDate || null,
    materials: data.materials || {},
    status: data.status,
  };
}

/** Maps a camelCase patch onto its column names for `.update()`. */
const PATCH_COLUMNS = {
  wears: "wears",
  lastWorn: "last_worn",
  lastCleaned: "last_cleaned",
  lastRotated: "last_rotated",
  condition: "condition",
  status: "status",
  value: "value",
  retail: "retail",
  materials: "materials",
};

export function patchToUpdate(patch) {
  const out = {};
  for (const [key, column] of Object.entries(PATCH_COLUMNS)) {
    if (key in patch) out[column] = patch[key];
  }
  return out;
}
